import React, { useEffect, useState } from 'react';
import { getConsent, onConsentChange, setConsent } from '../utils/analytics';

/**
 * Analytics consent banner. Shown until the visitor answers. Nothing is
 * tracked before "Allow" (see utils/analytics.js). The answer can be changed
 * any time in Settings.
 */
const ConsentBanner = ({ onShowPrivacy }) => {
  const [answered, setAnswered] = useState(() => !!getConsent());
  useEffect(() => onConsentChange(() => setAnswered(true)), []);
  if (answered) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Analytics consent"
      style={{
        position: 'fixed', left: 16, right: 16, bottom: 16, zIndex: 99999,
        maxWidth: 520, margin: '0 auto',
        backgroundColor: 'var(--card-bg-solid, #111820)', color: 'var(--text-primary, #f0f4f8)',
        border: '1px solid var(--card-border, rgba(255,255,255,0.1))', borderRadius: 12,
        boxShadow: '0 12px 40px rgba(0,0,0,0.35)', padding: '14px 16px',
        display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12,
      }}
    >
      <p style={{ flex: '1 1 260px', margin: 0, fontSize: 13, lineHeight: 1.5, color: 'var(--text-secondary, #b8c4d0)' }}>
        Can we use analytics (PostHog) to see whether your daily brief helps — if you open it and
        what you tap? Nothing else in the app is tracked. No ads, nothing sold.{' '}
        {onShowPrivacy && (
          <button type="button" onClick={onShowPrivacy}
            style={{ background: 'none', border: 0, padding: 0, color: '#2dd4bf', cursor: 'pointer', font: 'inherit', textDecoration: 'underline' }}>
            Privacy policy
          </button>
        )}
      </p>
      <div style={{ display: 'flex', gap: 8 }}>
        <button type="button" onClick={() => setConsent(false)}
          style={{ padding: '8px 14px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
            background: 'transparent', color: 'var(--text-secondary, #b8c4d0)',
            border: '1px solid var(--border-default, rgba(255,255,255,0.15))' }}>
          No thanks
        </button>
        <button type="button" onClick={() => setConsent(true)}
          style={{ padding: '8px 14px', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer',
            background: '#2dd4bf', color: '#0a0f14', border: 0 }}>
          Allow
        </button>
      </div>
    </div>
  );
};

export default ConsentBanner;
